import type { ErrorType } from '~/data/ErrorRecord';
import type { UserFields } from '~/components/containers/UserManagementContainer/data/User';

export const defaultState: Fields = {
  isLoading: false,
  isModalOpen: false,
  user: undefined,
  error: undefined,
  isSuccess: false,
  forceReload: false,
};

export interface Fields {
  isLoading: boolean;
  isModalOpen: boolean;
  user?: UserFields;
  error?: ErrorType;
  isSuccess?: boolean;
  forceReload?: boolean;
}
